import { mande, type MandeError } from 'mande'
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'

interface SearchItem {
  tenant: string
  published_at: string
  read_minute_duration: number
  title: string
  summary: string
  slug: string
  url: string
  type: string
}

interface SearchList {
  data: SearchItem[]
  page: number
  page_size: number
  total: number
  total_pages: number
}

interface SuggestionItem {
  tenant: string
  title: string
  slug: string
  url: string
  type: string
}

export function useSearchList() {
  const config = useRuntimeConfig()
  const api = mande(`${config.public.apiBaseUrl}/search`)
  const language = useI18n().locale.value.split('-')[0]
  const searchList = ref<SearchList | null>(null)
  const loading = ref<boolean>(true)
  const error = ref<MandeError | null>(null)

  const fetchSearchList = async (q: string = '', tenant: string = '') => {
    try {
      const response = await api.get<{ payload: SearchList }>('', {
        headers: {
          'Accept-Language': language,
        },
        query: {
          q,
          tenant,
        },
      })
      searchList.value = response.payload
    } catch (apiError) {
      error.value = apiError as MandeError
    } finally {
      loading.value = false
    }
  }

  return {
    searchList,
    fetchSearchList,
    loading,
    error,
  }
}

export function useSuggestionList() {
  const config = useRuntimeConfig()
  const api = mande(`${config.public.apiBaseUrl}/search`)
  const language = useI18n().locale.value.split('-')[0]
  const suggestionList = ref<SuggestionItem[]>([])
  const loading = ref<boolean>(true)
  const error = ref<MandeError | null>(null)

  const fetchSuggestionList = async (q: string = '') => {
    try {
      if (q.length > 3) {
        const response = await api.get<{ payload: SuggestionItem[] }>('suggestions', {
          headers: {
            'Accept-Language': language,
          },
          query: {
            q,
          },
        })
        suggestionList.value = response.payload
      }
    } catch (apiError) {
      error.value = apiError as MandeError
    } finally {
      loading.value = false
    }
  }

  fetchSuggestionList().then(() => {})

  return {
    suggestionList,
    fetchSuggestionList,
    loading,
    error,
  }
}
